import { apiClient } from '@/http/apiClient';
import { AxiosPromise } from 'axios';
const rootPath = 'SapApi';


class SapApiService {
    public getServicesUrl(poNumber:string, itemNumber:string, lang:string): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}/services/${poNumber}/${itemNumber}/${lang}`;
    }
    public getServices(poNumber:string, itemNumber:string, lang:string): AxiosPromise{
        return apiClient.get(this.getServicesUrl(poNumber,itemNumber,lang))
    }

    public getSendBopUrl(bopId:string): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}/send/${bopId}`;
    }

    public getValidateBopUrl(bopId:string): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}/validate/${bopId}`;
    }

    public sendBop(bopId:string,validation:any){
         return apiClient.post(this.getSendBopUrl(bopId),validation);
    }

    public validateBop(bopId:string,validation:any){
        return apiClient.post(this.getValidateBopUrl(bopId),validation);
     }
}

export default new SapApiService();